(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elmayorista-header-drawer"] && !Shopify.designMode) return;
  try {
    const initCuratedDrawers = () => {
    document.querySelectorAll('.em-curated-drawer #Details-menu-drawer-container').forEach((details) => {
      if (details.dataset.emCuratedDrawerReady === 'true') return;
      details.dataset.emCuratedDrawerReady = 'true';

      const summary = details.querySelector('.header__icon--menu');
      const drawer = details.querySelector('.menu-drawer');
      const backdrop = details.querySelector('.menu-drawer__backdrop');
      const closeControls = details.querySelectorAll('.em-curated-drawer__close, .menu-drawer__backdrop');
      const syncState = () => {
        const isOpen = details.hasAttribute('open');
        details.classList.toggle('menu-open', isOpen);
        summary?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (drawer) {
          drawer.getAnimations().forEach((animation) => animation.cancel());

          if (isOpen) {
            drawer.style.setProperty('transform', 'translateX(0)', 'important');
            drawer.style.setProperty('visibility', 'visible', 'important');
            drawer.style.setProperty('opacity', '1', 'important');
          } else {
            drawer.style.removeProperty('transform');
            drawer.style.removeProperty('visibility');
            drawer.style.removeProperty('opacity');
          }
        }

        if (backdrop) {
          if (isOpen) {
            backdrop.style.setProperty('opacity', '1', 'important');
            backdrop.style.setProperty('pointer-events', 'auto', 'important');
          } else {
            backdrop.style.removeProperty('opacity');
            backdrop.style.removeProperty('pointer-events');
          }
        }
      };

      details.addEventListener('toggle', syncState);
      summary?.addEventListener('click', () => {
        window.setTimeout(syncState, 0);
        window.setTimeout(syncState, 120);
      });
      new MutationObserver(syncState).observe(details, {
        attributes: true,
        attributeFilter: ['open', 'class'],
      });
      closeControls.forEach((control) => {
        control.addEventListener('click', () => {
          details.removeAttribute('open');
          syncState();
        });
      });
      details.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          details.removeAttribute('open');
          syncState();
          summary?.focus();
        }
      });

      syncState();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCuratedDrawers);
  } else {
    initCuratedDrawers();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elmayorista-header-menu"] && !Shopify.designMode) return;
  try {
    const initializeBuyerMenus = () => {
    document.querySelectorAll('[data-em-curated-menu]').forEach((menu) => {
      if (menu.dataset.emBuyerMenuReady === 'true') return;
      menu.dataset.emBuyerMenuReady = 'true';
      const groups = [...menu.querySelectorAll('details')];

      groups.forEach((group) => {
        group.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !group.open) return;
          event.preventDefault();
          group.open = false;
          group.querySelector('summary')?.focus();
        });
        group.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!group.contains(document.activeElement)) group.open = false;
          });
        });
      });

      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target)) groups.forEach((group) => { group.open = false; });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBuyerMenus, { once: true });
  } else {
    initializeBuyerMenus();
  }
  document.addEventListener('shopify:section:load', initializeBuyerMenus);
  } catch(e) { console.error(e); }
})();

})();
